export function elementorCustom() {
  //expand text
  const elements = document.querySelectorAll('.toggle-readmore');
  for (let count = 0; count < elements.length; ++count) {
    elements[count].addEventListener('click', function (event) {
      event.preventDefault();
      this.previousSibling.classList.toggle('show-text');
      this.classList.toggle('active');
    }, false);
  }
  //accordion products desktop
  const buttons = document.querySelectorAll('.readmore-plus');
  for (let count = 0; count < buttons.length; ++count) {
    buttons[count].addEventListener('click', function (event) {
      event.preventDefault();
      this.parentNode.parentNode.parentNode.classList.toggle('open-box');
      this.classList.toggle('active');
    }, false);

  }
  const products = document.querySelectorAll('.readmore-product');
  const boxProducts = document.querySelectorAll('.box-product-detail');
  const rowDetail = document.querySelector('.row-detail');
  for (let count = 0; count < products.length; ++count) {
    products[count].addEventListener('click', function (event) {
      event.preventDefault();
      let dataId = this.getAttribute('data-id');
      let thisContainer = this.parentNode.parentNode;
      //buttons active
      buttonActive(products, dataId);

      if (this.classList.contains('active')) {
        this.classList.remove('active');
        thisContainer.classList.remove('active');
      } else {
        this.classList.add('active');
        thisContainer.classList.add('active');
      }
      //box active
      boxActive(boxProducts, dataId, 'open-box');
      //clear height
      clearHeight(boxProducts,0,'open-box');

    }, false);
  }

  //accordion products mobile
  const titleMobile = document.querySelectorAll('.container-title-mobile');
  for (let count = 0; count < titleMobile.length; ++count) {
    titleMobile[count].addEventListener('click', function (event) {
      let dataId = this.getAttribute('data-id');
      event.preventDefault();
      /* boxActive(boxProducts, dataId, 'open-box-mobile'); */
      this.parentNode.parentNode.classList.toggle('open-box-mobile');
    }, false);
  }

  function buttonActive(elements, dataId) {
    for (let count = 0; count < elements.length; ++count) {
      if (dataId != elements[count].getAttribute('data-id')) {
        let container = elements[count].parentNode.parentNode;
        elements[count].classList.remove('active');
        container.classList.remove('active');
      }
    }
  }

  function boxActive(elements, dataId, classItem) {
    for (let i = 0; i < elements.length; i++) {
      let boxId = elements[i].id;
      if (elements[i].classList.contains(classItem) && boxId == dataId) {
        elements[i].style.transitionDuration = "0.4s";
        removeActive(elements[i], 0,classItem);
      } else {
        if (boxId != dataId) {
          removeActive(elements[i], 0,classItem);
        } else {
          elements[i].style.display = "flex";
          setHeight(elements[i], 0);
        }
      }
    }
  }
  function removeActive(el, time, classItem) {
    setTimeout(() => {
      el.style.opacity = "0";
      el.classList.remove(classItem);
    }, time);
  }
  function setHeight(el, time) {
    setTimeout(() => {
      el.style.opacity = "1";
      el.classList.add('open-box');
      let heightRow = rowDetail.childNodes.offsetHeight;
      rowDetail.style.height = heightRow + 'px';
    }, time);
  }
  function clearHeight(elements,time,classItem) {
    setTimeout(() => {
      let numb = 0;
      for (let i = 0; i < elements.length; i++) {
        if (elements[i].classList.contains(classItem)) {
          numb++;
        }
      }
      /* console.log(numb); */
      if (!numb) {
        rowDetail.removeAttribute('style');
      }
    }, time);
  }
}
